import React from "react"
import ReviewForm from "./ReviewForm"
import Review from "./Review"

class MyReview extends React.Component{
    constructor(){
        super()
        this.state = {
            edit: false
        }
    }
    editReview = () =>{
        this.setState({edit: true})
    }
    cancelEdit = (review) =>{
        this.props.updateMyReview(review)
        this.setState({edit: false})
    }
    render(){
        const { myReview, data } = this.props
        return(
            <div className="section" id="rateGameDiv">
                {myReview === null 
                    ? <>
                        <h2 className="sectionTitle">Review this Game!</h2>
                        <ReviewForm data={data} editReview={false}
                                    upvote={null} cancelEdit={this.cancelEdit}
                                    updateMyReview={this.props.updateMyReview}/>
                    </>
                    : myReview.content === null || myReview.upvote === null ?
                    <>
                        <h2 className="sectionTitle">Review this Game!</h2>
                        <ReviewForm data={data} editReview={false}
                                    upvote={myReview.upvote} cancelEdit={this.cancelEdit}
                                    updateMyReview={this.props.updateMyReview}/>
                    </>
                    :<>
                        <h2 className="sectionTitle">My Review</h2>
                        <div className="description">
                            {this.state.edit === false
                            ? <Review upvote={myReview.upvote} comment={myReview.content} date={myReview.updatedAt} 
                               editable={true} editReview={this.editReview}/>
                            : <ReviewForm data={data} comment={myReview.content} editReview={true}
                                        upvote={myReview.upvote} cancelEdit={this.cancelEdit} 
                                        updateMyReview={this.props.updateMyReview}/>
                            }
                        </div>
                    </>}
            </div>
        )
    }
}

export default MyReview